<template>
  <div class="public-content theme-management">
    <div class="region-title" style="background: #fff">尺寸组类管理</div>
    <div class="add-category" v-permission="'pts:admin:compose:size:group:category:add'">
      <el-button round type="primary" @click="categoryName = '', type = 'add', dialogVisible = true">新建尺寸组类</el-button>
    </div>
    <div class="data-list">
      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
        <el-table-column min-width="200px" prop="categoryName" label="尺寸组类">
        </el-table-column>
        <el-table-column min-width="200px" label="操作">
          <template slot-scope="scope">
            <span class="color-blue" v-permission="'pts:admin:compose:size:group:category:update'"
              @click="categoryName = scope.row.categoryName, editSizeGroupTypeId = scope.row.id, type = 'edit', dialogVisible = true">编辑</span><br />
            <span class="color-blue" v-permission="'pts:admin:compose:size:group:category:delete'" @click="deleteId = scope.row.id, deleteDialog = true">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    <!-- 新建/编辑尺寸组类 -->
    <el-dialog :close-on-click-modal="false" title="尺寸组类" :visible.sync="dialogVisible" width="30%">
      <span>尺寸组类：</span>
      <el-input style="width:60%" v-model="categoryName" placeholder="" maxlength="20"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>是否确认删除？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteSizeGroupType(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { groupCategoryListPage, composeGroupCategoryAdd, sizeGroupCategoryDelete, groupCategoryUsable, groupCategoryUpdate } from '@/api/pms'
export default {
  name: 'theme-management',
  components: {
    VPagination
  },
  data () {
    return {
      deleteId: '',
      deleteDialog: false,
      categoryName: '',
      dialogVisible: false,
      type: '',
      editSizeGroupTypeId: '',
      tableData: [],
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getSizeGroupTypeList()
  },
  methods: {
    // 删除
    deleteSizeGroupType (id) {
      sizeGroupCategoryDelete(id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.getSizeGroupTypeList()
        }
        this.deleteDialog = false
      })
    },
    // 新建/编辑尺寸组类
    onSubmit () {
      if (!this.categoryName) {
        this.$message.error('请填写尺寸组类名称')
        return
      }
      if (this.type === 'add') {
        // 验名字
        groupCategoryUsable({ act: 0, categoryName: this.categoryName }).then(res => {
          if (res.data.success) {
            composeGroupCategoryAdd({ categoryName: this.categoryName }).then(res => {
              if (res.data.success) {
                this.$message.success('添加成功')
                this.getSizeGroupTypeList()
                this.dialogVisible = false
              }
            })
          }
        })
      } else if (this.type === 'edit') {
        groupCategoryUsable({ act: 1, categoryName: this.categoryName, groupCategoryId: this.editSizeGroupTypeId }).then(res => {
          if (res.data.success) {
            groupCategoryUpdate({ id: this.editSizeGroupTypeId, params: { categoryName: this.categoryName } }).then(res => {
              if (res.data.success) {
                this.$message.success('修改成功')
                this.getSizeGroupTypeList()
                this.dialogVisible = false
              }
            })
          }
        })
      }
    },
    // 获取尺寸组类
    getSizeGroupTypeList () {
      groupCategoryListPage({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize }).then(res => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getSizeGroupTypeList()
    }
  }
}
</script>
<style scoped lang="less">
@import "./styles";
@deep: ~">>>";
</style>
